import { topInfoSlide } from './_top_info_slide.js';
import { reActive } from '../page/_pushstate.js';
export let home = {
	movieDom: null,
	movieID: "",
	options: {},
	player: null,
	timer: null,
	endScroll: false,
	init: function(){
		home.movieDom = document.querySelector(".s-kv .movie");
		
		//console.log(home.movieDom)
		if( home.movieDom ){
			home.stopScroll();
			home.loadVimeo();
		}
	},
	loadVimeo: function(){
		home.movieID	= home.movieDom.getAttribute("data-movie-id");
		//console.log(home.movieID);
		
		home.options = {
			url: `https://vimeo.com/${home.movieID}`,
			byline: false, // 投稿者部分の表示
			portrait: false, // 左上のVimeoのマークの表示
			title: false, // タイトルの表示
			autoplay: 1,
			controls: 0,
			muted: 1,
			pip: 0,
			loop: 1,
			playsinline: 1
		}
		home.player = new Vimeo.Player(home.movieDom, home.options);
		
		home.player.ready().then(() => {
			home.timer = setInterval( home.checkTime, 100);
		});
	},
	checkTime: function(){
		let transformSec = 2.2;
		if( document.documentElement.classList.contains("mobile") ){
			setTimeout(function(){
				transformSec = 0;
				document.documentElement.classList.add("active_top");
				reActive.nav();
				clearInterval( home.timer );
				document.documentElement.classList.add("set_logo");
				document.documentElement.classList.remove("disable_scroll");
				home.startScroll();
			}, 1000);
		}else{
			home.player.getCurrentTime().then(function(seconds) {
				//console.log(seconds)
				if( seconds >= transformSec ){
					document.documentElement.classList.add("active_top");
					reActive.nav();
					clearInterval( home.timer );
					setTimeout(function(){
						document.documentElement.classList.add("set_logo");
						document.documentElement.classList.remove("disable_scroll");
						home.startScroll();
					}, 1300);
				}
			});
		}
		
	},
	stopScroll: function(){
		document.removeEventListener("sheel", home.stopPropagation, false);
		document.addEventListener("sheel", home.stopPropagation, false);
		//document.documentElement.classList.add("disable_scroll");
	},
	stopPropagation: function(e){
		e.stopPropagation();
	},
	startScroll: function(){
		document.removeEventListener("sheel", home.stopPropagation, false);
		if( !home.endScroll ){
			home.endScroll = true;
			topInfoSlide.init();
		}
	}
}